import { Avatar } from '@mui/material';
import React from 'react';
import { ThreadedComment } from 'Types/comment';

interface CommentAvatarProps {
  comment: ThreadedComment;
}

const avatarColors = [
  '#F6EB21',
  '#0047FF',
  '#50658E',
  '#00e9fb',
  '#22d469',
  '#ffc700',
  '#f802d2',
  '#b841ff',
  '#00fcb3',
  '#01a5ff',
  '#ff8a00',
  '#CED7E6',
  '#0047FF',
  '#E8EEF8',
];

const getColorFromName = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % avatarColors.length;
  return avatarColors[index];
};

export const CommentAvatar: React.FC<CommentAvatarProps> = ({ comment }) => {
  const color = getColorFromName(comment.createdByName);
  const initial = comment.createdByName.charAt(0).toUpperCase();

  return <Avatar sx={{ bgcolor: color }}>{initial}</Avatar>;
};
